module.exports = __webpack_public_path__ + "img/OT462.abb1cd4.jpg";